import PropTypes from 'prop-types';

export const DocumentTypeKeys = ['Policies', 'ClaimDocuments', 'OtherDocuments'];

export const DocumentPropTypes = PropTypes.shape({
  claimNumber: PropTypes.string,
  policyNumber: PropTypes.string,
  contactId: PropTypes.string,
  attachmentNumber: PropTypes.number,
  attachmentId: PropTypes.number,
  sentDate: PropTypes.string,
  description: PropTypes.string,
  isShown: PropTypes.bool,
  animalName: PropTypes.string,
  planDescription: PropTypes.string
});

export const SimplifiedDocumentDataPropTypes = PropTypes.shape({
  Policies: PropTypes.arrayOf(DocumentPropTypes),
  ClaimDocuments: PropTypes.arrayOf(DocumentPropTypes),
  OtherDocuments: PropTypes.arrayOf(DocumentPropTypes)
});

export const TableFilterPropTypes = PropTypes.shape({
  policy: PropTypes.string,
  fromDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  toDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  type: PropTypes.string
});
